(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["botanical-index"] && !Shopify.designMode) return;
  try {
    
  /* Botanical Index selector. Turns the section's entries into one shared
     place with an index that switches between them (the tabs pattern):
     click or tap, arrow keys, Home and End. It only runs where CSS subgrid is
     available; anywhere else, and without JavaScript, every entry stays
     visible in full and nothing is lost. */
  (() => {
    if (customElements.get('botanical-index')) return;

    class BotanicalIndex extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        if (!window.CSS || !CSS.supports('grid-template-columns', 'subgrid')) return;

        const tabs = Array.from(this.querySelectorAll('[data-botanical-tab]'));
        const panels = tabs.map((tab) => this.querySelector(`#${CSS.escape(tab.dataset.entry)}`));
        const tablist = this.querySelector('[data-botanical-tablist]');
        if (!tablist || !tabs.length || panels.some((panel) => !panel)) return;

        this.tabs = tabs;
        this.panels = panels;
        this.tablist = tablist;
        this.desktopQuery = window.matchMedia('(min-width: 48rem)');

        tablist.setAttribute('role', 'tablist');
        tablist.setAttribute('aria-orientation', 'vertical');

        tabs.forEach((tab, index) => {
          const panel = panels[index];
          tab.id = `${panel.id}-tab`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);

          tab.addEventListener('click', (event) => this.select(index, { scroll: event.detail > 0 }));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          /* Start fetching a photograph as soon as its row is pointed at or
             focused, so it is usually ready by the time it is chosen. */
          tab.addEventListener('pointerenter', () => this.prime(index));
          tab.addEventListener('focus', () => this.prime(index));
        });

        /* In the Theme Editor, selecting a block shows that ingredient. */
        this.addEventListener('shopify:block:select', (event) => {
          const index = panels.indexOf(event.target.closest('[data-botanical-panel]'));
          if (index > -1) this.select(index, { reveal: true });
        });

        this.select(0);
        this.setAttribute('data-enhanced', '');

        this.fitQuery = window.matchMedia('(min-width: 72rem)');
        const fit = () => this.fit();
        this.fitQuery.addEventListener('change', fit);
        new ResizeObserver(fit).observe(this);
        document.fonts?.ready.then(fit);
        fit();
      }

      /* Desktop: trim the scrolling index to the whole rows that fit beside
         the plate, so its resting state always ends on a complete row. */
      fit() {
        const list = this.tablist;
        if (!this.fitQuery.matches) {
          this.style.removeProperty('--botanical-index-fit');
          return;
        }

        const rows = getComputedStyle(this).gridTemplateRows.split(' ').map(parseFloat);
        const gap = parseFloat(getComputedStyle(this).rowGap) || 0;
        const plate = this.panels[0].querySelector('.entry__media');
        if (!plate || rows.length < 2) return;

        const listStyle = getComputedStyle(list);
        const frame = parseFloat(listStyle.paddingTop) + parseFloat(listStyle.borderBottomWidth);
        const available = plate.getBoundingClientRect().height - rows[0] - gap - frame;

        let used = 0;
        let count = 0;
        for (const tab of this.tabs) {
          const next = used + tab.getBoundingClientRect().height;
          if (next > available + 0.5) break;
          used = next;
          count += 1;
        }

        if (count === 0 || count === this.tabs.length) {
          this.style.removeProperty('--botanical-index-fit');
        } else {
          this.style.setProperty('--botanical-index-fit', `${Math.floor((used + frame) * 100) / 100}px`);
        }
      }

      select(index, { focus = false, scroll = false, reveal = false } = {}) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });

        this.panels.forEach((panel, i) => {
          panel.toggleAttribute('data-active', i === index);
        });

        /* The neighbours are the likeliest next choice by keyboard. */
        this.prime(index - 1);
        this.prime(index + 1);

        if (focus) this.tabs[index].focus({ preventScroll: true });
        if (focus || reveal) this.reveal(this.tabs[index]);

        /* On a phone the index sits below the entry it changes, so bring that
           entry back into view if a tap has left it above the screen. */
        if (scroll && !this.desktopQuery.matches && this.getBoundingClientRect().top < 0) {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        }
      }

      prime(index) {
        this.panels[index]?.setAttribute('data-primed', '');
      }

      /* On desktop the index scrolls within its own column: bring the chosen
         row fully into that column, never moving the page itself. */
      reveal(tab) {
        const list = this.tablist;
        if (list.scrollHeight <= list.clientHeight) return;

        const top = tab.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
        const bottom = top + tab.offsetHeight;
        let target = null;

        if (top < list.scrollTop) target = top;
        else if (bottom > list.scrollTop + list.clientHeight) target = bottom - list.clientHeight;
        if (target === null) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollTo({ top: target, behavior: reduced ? 'auto' : 'smooth' });
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;

        if (next === null) return;
        event.preventDefault();
        this.select(next, { focus: true });
      }
    }

    customElements.define('botanical-index', BotanicalIndex);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-formulation"] && !Shopify.designMode) return;
  try {
    
  /* Plays the Featured Formulation entrance once per page load. It arms only
     when the section is still below the fold (so nothing already on screen
     ever disappears), reveals when a fifth of it is in view, then removes its
     classes so the static design is all that remains. */
  class FormulationReveal extends HTMLElement {
    connectedCallback() {
      if (this.dataset.revealed) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (this.getBoundingClientRect().top < window.innerHeight) return;

      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.reveal();
        },
        { threshold: 0.2 }
      );
      this.observer.observe(this.closest('.formulation') || this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.settleTimer);
    }

    reveal() {
      this.observer.disconnect();
      this.dataset.revealed = 'true';
      this.classList.add('is-revealed');

      // Settle when the link, the last step, has finished fading in; the
      // timer is a fallback for a missing link or a paused background tab.
      const settle = () => {
        clearTimeout(this.settleTimer);
        this.classList.remove('is-armed', 'is-revealed');
      };
      const last = this.querySelector('.formulation__action');
      last?.addEventListener('transitionend', (event) => {
        if (event.target === last && event.propertyName === 'opacity') settle();
      });
      this.settleTimer = setTimeout(settle, 2500);
    }
  }

  if (!customElements.get('formulation-reveal')) {
    customElements.define('formulation-reveal', FormulationReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const message = document.querySelector('[data-footer-newsletter-message]');
    if (message) message.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('site-header')) {
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.dialog = this.querySelector('[data-mobile-menu]');
        this.opener = this.querySelector('[data-mobile-menu-open]');
        this.items = Array.from(this.querySelectorAll('[data-nav-item]'));

        this.opener?.addEventListener(
          'click',
          () => {
            this.dialog.showModal();
            this.opener.setAttribute('aria-expanded', 'true');
          },
          { signal }
        );

        this.dialog?.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-mobile-menu-close], a')) this.dialog.close();
          },
          { signal }
        );

        this.dialog?.addEventListener(
          'close',
          () => {
            this.opener?.setAttribute('aria-expanded', 'false');
            this.opener?.focus();
          },
          { signal }
        );

        window
          .matchMedia('(min-width: 72rem)')
          .addEventListener('change', (event) => event.matches && this.dialog?.open && this.dialog.close(), { signal });

        this.items.forEach((item) => {
          const toggle = item.querySelector('[data-nav-toggle]');
          if (!toggle) return;

          toggle.addEventListener(
            'click',
            (event) => {
              const isOpen = item.classList.contains('is-open');

              // A mouse click on a panel that hover just opened keeps it open (pinned)
              // instead of immediately closing it again.
              if (isOpen && !item.dataset.pinned && event.detail > 0) {
                item.dataset.pinned = 'true';
                return;
              }

              this.closeAll(item);
              this.setOpen(item, !isOpen);
              if (!isOpen) item.dataset.pinned = 'true';
            },
            { signal }
          );

          item.addEventListener(
            'pointerenter',
            (event) => {
              if (event.pointerType !== 'mouse') return;
              this.closeAll(item);
              this.setOpen(item, true);
            },
            { signal }
          );

          item.addEventListener(
            'pointerleave',
            (event) => {
              if (event.pointerType === 'mouse' && !item.dataset.pinned) this.setOpen(item, false);
            },
            { signal }
          );

          item.addEventListener(
            'focusout',
            (event) => {
              if (!item.contains(event.relatedTarget)) this.setOpen(item, false);
            },
            { signal }
          );

          item.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
              this.setOpen(item, false);
              toggle.focus();
            },
            { signal }
          );
        });

        document.addEventListener(
          'click',
          (event) => {
            if (!this.contains(event.target)) this.closeAll();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort.abort();
      }

      setOpen(item, open) {
        item.classList.toggle('is-open', open);
        if (!open) delete item.dataset.pinned;
        item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', String(open));
      }

      closeAll(except) {
        this.items.forEach((item) => item !== except && this.setOpen(item, false));
      }
    }

    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
  /* Reels play muted and looped only while they are on screen, so a page of
     them never streams video nobody is watching. With reduced motion the
     cover frame stays still. Videos load nothing until first needed. */
  if (!customElements.get('instagram-reels')) {
    customElements.define(
      'instagram-reels',
      class InstagramReels extends HTMLElement {
        connectedCallback() {
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.videos = Array.from(this.querySelectorAll('video'));
          if (!this.videos.length || !('IntersectionObserver' in window)) return;

          this.observer = new IntersectionObserver((entries) => this.update(entries), { threshold: 0.25 });
          this.videos.forEach((video) => this.observer.observe(video));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        update(entries) {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting && !this.motion.matches) {
              target.preload = 'auto';
              const playing = target.play();
              if (playing) playing.catch(() => {});
            } else {
              target.pause();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noralusin-standard"] && !Shopify.designMode) return;
  try {
    
  /* The Noralusin Standard, phone selector. Wires the numeral row under the
     standards to the list above it: a tap scrolls to that standard, a swipe
     updates which numeral is current, and the arrow keys move between them.
     The list itself scrolls natively; on tablet and desktop none of this
     shows, and without the script the list stays stacked. */
  (() => {
    if (customElements.get('standard-nav')) return;

    class StandardNav extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.standard');
        const list = section?.querySelector('.standard__list');
        if (!list || this.list) return;

        this.list = list;
        this.items = Array.from(list.children);
        this.buttons = Array.from(this.querySelectorAll('button'));
        if (this.items.length !== this.buttons.length) return;

        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.go(index));
          button.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        list.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.sync());
          },
          { passive: true }
        );

        section.addEventListener('shopify:block:select', (event) => {
          const index = this.items.indexOf(event.target.closest('.principle'));
          if (index > -1) this.go(index);
        });

        this.hidden = false;
        section.setAttribute('data-principles', '');
        this.sync();
      }

      current() {
        const width = this.list.clientWidth;
        if (!width) return 0;
        return Math.min(this.items.length - 1, Math.max(0, Math.round(this.list.scrollLeft / width)));
      }

      go(index, { focus = false } = {}) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const left = this.items[index].offsetLeft - this.items[0].offsetLeft;
        this.list.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
        this.mark(index);
        if (focus) this.buttons[index].focus();
      }

      sync() {
        this.mark(this.current());
      }

      mark(index) {
        this.buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      }

      onKeydown(event, index) {
        const last = this.buttons.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.go(next, { focus: true });
      }
    }

    customElements.define('standard-nav', StandardNav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function linkIngredientRows() {
      document.querySelectorAll('[data-ingredients-link]').forEach(function (link) {
        var row = document.getElementById('pdp-row-ingredients');
        if (!row || link.dataset.bound) return;
        link.dataset.bound = 'true';
        link.hidden = false;
        link.addEventListener('click', function (event) {
          event.preventDefault();
          row.open = true;
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var summary = row.querySelector('summary');
          if (summary) summary.focus({ preventScroll: true });
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkIngredientRows);
    else linkIngredientRows();
    document.addEventListener('shopify:section:load', linkIngredientRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Visibility is read from the current layout on every scroll frame, so a
     restored scroll position, a jump link or a fast flick that never lets the
     purchase area cross the viewport edge still shows the bar. */
  class PdpStickyBar extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-product-root]');
      this.form = root && root.querySelector('.pdp__form');
      this.add = root && root.querySelector('[data-add]');
      this.price = root && root.querySelector('[data-price] .pdp-price__now');
      this.button = this.querySelector('[data-bar-add]');
      this.priceOut = this.querySelector('[data-bar-price]');
      this.footer = document.querySelector('.site-footer');
      if (!this.form || !this.add || !this.button) return;

      this.hidden = false;
      this.frame = 0;

      this.button.addEventListener('click', () => {
        if (!this.add.disabled) this.add.click();
      });

      this.sync = this.sync.bind(this);
      this.mirror = new MutationObserver(this.sync);
      this.mirror.observe(this.add, { attributes: true, childList: true, subtree: true, characterData: true });
      if (this.price) this.mirror.observe(this.price, { childList: true, subtree: true, characterData: true });

      this.schedule = this.schedule.bind(this);
      this.abort = new AbortController();
      const options = { passive: true, signal: this.abort.signal };
      ['scroll', 'resize', 'hashchange', 'load', 'pageshow', 'popstate'].forEach((type) => window.addEventListener(type, this.schedule, options));
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(document.body);

      this.sync();
      this.update();
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.mirror) this.mirror.disconnect();
      if (this.resize) this.resize.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    }

    update() {
      const formAbove = this.form.getBoundingClientRect().bottom <= 0;
      const footerNear = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
      this.toggleAttribute('data-shown', formAbove && !footerNear);
    }

    sync() {
      const label = this.add.querySelector('[data-add-label]');
      this.button.textContent = (label ? label.textContent : this.add.textContent).trim();
      this.button.disabled = this.add.disabled || this.add.getAttribute('aria-disabled') === 'true';
      if (this.price && this.priceOut) this.priceOut.textContent = this.price.textContent.trim();
    }
  }

  if (!customElements.get('pdp-sticky-bar')) customElements.define('pdp-sticky-bar', PdpStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-pairings"] && !Shopify.designMode) return;
  try {
    
  /* Ritual Pairings selector. Turns the section's rituals into one shared
     place with a ledger that switches between them (the tabs pattern): click
     or tap, arrow keys, Home and End. Without JavaScript every ritual stays
     visible in full, one after another, and nothing is lost.

     The rituals not showing hold lazy images, so once the section is near the
     screen (or a tab is pointed at or focused) their photographs are fetched
     ahead of time, and switching never meets an empty plate. */
  (() => {
    if (customElements.get('ritual-pairings')) return;

    class RitualPairings extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;

        const tabs = Array.from(this.querySelectorAll('[data-pairings-tab]'));
        const panels = tabs.map((tab) => this.querySelector(`#${CSS.escape(tab.dataset.panel)}`));
        const tablist = this.querySelector('[data-pairings-tablist]');
        if (!tablist || !tabs.length || panels.some((panel) => !panel)) return;

        this.tabs = tabs;
        this.panels = panels;
        this.current = 0;

        tablist.setAttribute('role', 'tablist');
        tablist.setAttribute('aria-orientation', 'horizontal');

        tabs.forEach((tab, index) => {
          const panel = panels[index];
          tab.id = `${panel.id}-tab`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);

          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          tab.addEventListener('pointerenter', () => this.warm(index));
          tab.addEventListener('focus', () => this.warm(index));
        });

        /* In the Theme Editor, selecting a ritual or one of its steps shows that ritual. */
        this.addEventListener('shopify:block:select', (event) => {
          const index = panels.indexOf(event.target.closest('[data-pairings-panel]'));
          if (index > -1) this.select(index);
        });

        this.select(0, { immediate: true });
        this.setAttribute('data-enhanced', '');
        this.warmWhenNear();

      }

      select(index, { focus = false, immediate = false } = {}) {
        /* Keep the selector where the reader left it: a taller ritual gives way
           to a shorter one below it, so only the page's end can move. */
        const before = immediate ? null : this.getBoundingClientRect().top;

        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });

        this.panels.forEach((panel, i) => {
          panel.toggleAttribute('data-active', i === index);
        });

        this.querySelectorAll('[data-pairings-cta]').forEach((link) => {
          link.hidden = link.dataset.pairingsCta !== this.panels[index].id;
        });

        /* The section's introduction follows the ritual, where it has one. */
        const section = this.closest('.pairings');
        if (section) {
          let hasIntro = false;
          section.querySelectorAll('[data-pairings-intro]').forEach((intro) => {
            const active = intro.dataset.pairingsIntro === this.panels[index].id;
            intro.toggleAttribute('data-active', active);
            if (active) hasIntro = true;
          });
          section.toggleAttribute('data-ritual-intro', hasIntro);
        }

        this.current = index;
        /* The ritual showing on load keeps the browser's own lazy loading; any
           other choice is fetched at once. */
        if (!immediate) this.warm(index);
        if (focus) this.tabs[index].focus({ preventScroll: true });

        if (before !== null) {
          const shift = this.getBoundingClientRect().top - before;
          if (Math.abs(shift) > 1) window.scrollBy(0, shift);
        }
      }

      /* Fetch the photographs of a ritual that is not showing. */
      warm(index) {
        const panel = this.panels[index];
        if (!panel || panel.hasAttribute('data-warm')) return;
        panel.setAttribute('data-warm', '');
        panel.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      }

      warmWhenNear() {
        const warmAll = () => this.panels.forEach((_, index) => this.warm(index));
        if (!('IntersectionObserver' in window)) {
          window.addEventListener('load', warmAll, { once: true });
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            warmAll();
          },
          { rootMargin: '600px 0px' }
        );
        observer.observe(this);
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;

        if (next === null) return;
        event.preventDefault();
        this.select(next, { focus: true });
      }
    }

    customElements.define('ritual-pairings', RitualPairings);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rituals"] && !Shopify.designMode) return;
  try {
    
  /* Shop by intention, phone carousel. Below 48rem the three intentions loop:
     a copy of the set is placed either side of the real cards (hidden from
     assistive technology and the keyboard), and whenever the row comes to rest
     on a copy it is moved, instantly and invisibly, to the matching real card.
     Every few seconds the row glides one card on; any touch, wheel, key or
     focus pauses that and it resumes after a quiet spell. Readers who ask for
     reduced motion keep the loop and swiping but no automatic movement. On
     tablet and desktop the copies are removed and nothing runs. */
  (() => {
    if (customElements.get('rituals-rail')) return;

    const DWELL = 3500;
    const RESUME = 6000;
    const GLIDE = 1000;
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

    class RitualsRail extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.rituals__list');
        if (!this.list || this.originals) return;
        this.originals = Array.from(this.list.children);
        if (this.originals.length < 2) return;

        this.phone = window.matchMedia('(max-width: 47.99rem)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMedia = () => this.update();
        this.phone.addEventListener('change', this.onMedia);
        this.reduced.addEventListener('change', this.onMedia);

        this.onScroll = () => this.scrolled();
        this.onInteract = () => this.interrupt();
        this.onFocusOut = () => {
          if (!this.contains(document.activeElement)) this.schedule(RESUME);
        };
        this.onVisibility = () => this.schedule(DWELL);

        this.update();
      }

      disconnectedCallback() {
        this.phone?.removeEventListener('change', this.onMedia);
        this.reduced?.removeEventListener('change', this.onMedia);
        this.teardown();
      }

      update() {
        if (this.phone.matches) this.setup();
        else this.teardown();
        this.schedule(DWELL);
      }

      setup() {
        if (this.looping) return;
        this.looping = true;

        const echo = (item) => {
          const copy = item.cloneNode(true);
          Array.from(copy.attributes)
            .filter((attribute) => attribute.name.startsWith('data-shopify'))
            .forEach((attribute) => copy.removeAttribute(attribute.name));
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.dataset.echo = '';
          return copy;
        };
        this.originals.forEach((item, index) => (item.dataset.ritual = index));
        this.before = this.originals.map(echo);
        this.after = this.originals.map(echo);
        this.list.prepend(...this.before);
        this.list.append(...this.after);
        this.items = Array.from(this.list.children);
        this.setAttribute('data-loop', '');

        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) =>
          this.list.addEventListener(type, this.onInteract, { passive: true })
        );
        this.list.addEventListener('focusin', this.onInteract);
        this.list.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.inView = entry.isIntersecting;
            this.schedule(DWELL);
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this.list);

        this.resizer = new ResizeObserver(() => {
          if (!this.gliding) this.jump(this.originals[this.current ?? 0]);
        });
        this.resizer.observe(this.list);
        this.resizer.observe(this.originals[0]);

        this.closest('.shopify-section')?.addEventListener('shopify:block:select', (this.onSelect = (event) => {
          const item = event.target.closest('.ritual');
          if (!this.originals.includes(item)) return;
          this.interrupt();
          this.glide(item);
        }));

        this.jump(this.originals[0]);
      }

      teardown() {
        if (!this.looping) return;
        this.looping = false;
        this.stop();
        clearTimeout(this.timer);
        clearTimeout(this.idle);
        [...this.before, ...this.after].forEach((item) => item.remove());
        this.originals.forEach((item) => {
          item.classList.remove('is-current');
          delete item.dataset.ritual;
        });
        this.removeAttribute('data-loop');
        this.list.removeEventListener('scroll', this.onScroll);
        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) =>
          this.list.removeEventListener(type, this.onInteract)
        );
        this.list.removeEventListener('focusin', this.onInteract);
        this.list.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.closest('.shopify-section')?.removeEventListener('shopify:block:select', this.onSelect);
        this.observer.disconnect();
        this.resizer.disconnect();
        this.list.scrollLeft = 0;
      }

      /* Scroll offset that puts an item's centre on the row's centre. */
      offsetFor(item) {
        const row = this.list.getBoundingClientRect();
        const box = item.getBoundingClientRect();
        return this.list.scrollLeft + box.left - row.left + (box.width - this.list.clientWidth) / 2;
      }

      nearest() {
        const centre = this.list.scrollLeft;
        let best = this.items[0];
        let distance = Infinity;
        this.items.forEach((item) => {
          const d = Math.abs(this.offsetFor(item) - centre);
          if (d < distance) {
            distance = d;
            best = item;
          }
        });
        return best;
      }

      mark(item) {
        const index = Number(item.dataset.ritual);
        this.current = index;
        this.items.forEach((each) => each.classList.toggle('is-current', each === item));
      }

      jump(item) {
        this.hush();
        this.list.scrollTo({ left: this.offsetFor(item), behavior: 'instant' });
        this.mark(item);
      }

      /* Scroll events from the script's own moves arrive a frame later; they
         must not read as the reader swiping. */
      hush() {
        this.quietUntil = performance.now() + 120;
      }

      scrolled() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.mark(this.nearest()));
        if (this.gliding || performance.now() < this.quietUntil) return;
        clearTimeout(this.timer);
        clearTimeout(this.idle);
        this.idle = setTimeout(() => this.settle(RESUME), 160);
      }

      /* The row has come to rest: trade a copy for its real card. */
      settle(delay) {
        const item = this.nearest();
        if (item.hasAttribute('data-echo')) {
          this.jump(this.originals[Number(item.dataset.ritual)]);
        } else {
          this.mark(item);
        }
        this.schedule(delay);
      }

      interrupt() {
        this.stop();
        this.schedule(RESUME);
      }

      stop() {
        clearTimeout(this.timer);
        if (!this.gliding) return;
        cancelAnimationFrame(this.glideFrame);
        this.gliding = false;
        this.list.style.scrollSnapType = '';
      }

      schedule(delay) {
        clearTimeout(this.timer);
        if (!this.looping || !this.inView || this.reduced.matches) return;
        if (document.visibilityState === 'hidden' || window.Shopify?.designMode) return;
        if (this.list.contains(document.activeElement)) return;
        this.timer = setTimeout(() => this.advance(), delay);
      }

      advance() {
        const index = this.items.indexOf(this.nearest());
        this.glide(this.items[index + 1]);
      }

      /* A slow eased glide; snapping is lifted while it runs, then restored
         exactly on the next card. */
      glide(item) {
        if (!item) return;
        this.stop();
        const from = this.list.scrollLeft;
        const to = this.offsetFor(item);
        const start = performance.now();
        this.gliding = true;
        this.list.style.scrollSnapType = 'none';

        const step = (now) => {
          const t = Math.min(1, (now - start) / GLIDE);
          this.list.scrollLeft = from + (to - from) * ease(t);
          if (t < 1) {
            this.glideFrame = requestAnimationFrame(step);
            return;
          }
          this.gliding = false;
          this.hush();
          this.list.style.scrollSnapType = '';
          this.settle(DWELL);
        };
        this.glideFrame = requestAnimationFrame(step);
      }
    }

    customElements.define('rituals-rail', RitualsRail);
  })();

  } catch(e) { console.error(e); }
})();
})();
